__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a9e92e9/_next/";